export default "__VITE_ASSET__e8d97e04__"